<template>
  <b-row class="app-section">
    <b-col class="h-100">
      <!--This contains the top buttons to go between pages-->
      <b-row style="height: 10%;">
        <b-col cols="auto" class="mr-auto p-3">
          <b-button id="v-step-1" :to="{ path: '/plot' }" class="mr-2">
            <i class="far fa-arrow-alt-circle-left"></i>
            Main plots page
          </b-button>
        </b-col>
        <b-col cols="auto" class="p-3">
          <!--Download alert that displays all the msgs from response and link to zip file-->
          <download-alert
            :chartId="`${chart.i}`"
            :chart="chart.chart"
            :traceId="currentTrace ? currentTrace.id : 0"
            :trace="currentTrace"
          ></download-alert>
        </b-col>
        <b-col cols="auto" class="p-3">
          <!--Download btn-->
          <!--Disables if there are no selected instruments or form is not ready-->
          <b-btn
            id="v-step-9"
            class="download-btn"
            variant="success"
            v-b-modal="`${chart.i}-download-form`"
            :disabled="!chart.hasData || traceInstruments.length === 0"
          >
            <i class="fas fa-download"></i>
            Download
            <i
              class="fas fa-info-circle download-disclaimer"
              v-b-popover.hover.bottom="downloadHoverContent"
              title="Data Download Disclaimer"
            ></i>
            <!-- <b-badge class="download-badge"> Coming<br />soon! </b-badge> -->
          </b-btn>
          <download-form
            :chartId="`${chart.i}`"
            :chart="chart"
            :traceId="currentTrace ? currentTrace.id : 0"
            :trace="currentTrace"
          ></download-form>
          <!--TODO: properly create chart object-->
          <b-btn
            id="v-step-12"
            :to="{ path: `/plot/${newChart.i}`, query: newChart.query }"
            class="ml-auto"
            variant="primary">
            <i class="fas fa-plus"></i>
            Add New Plot
          </b-btn>
        </b-col>
      </b-row>
      <b-row style="height: 90%;">
        <b-col cols="12" class="h-100 w-100">
          <b-tabs
            class="h-100 w-100"
            content-class="detail-container pt-3 pb-1"
            nav-wrapper-class="detail-nav"
            nav-class="border-top-bottom"
            active-nav-item-class="bold-bottom-line"
            v-model="tabIndex"
          >
            <!-- This tabs content will always be mounted -->
            <b-tab lazy class="h-100" title-link-class="detail-nav-link">
              <template #title>
                Data selections
                <i
                  class="fas fa-info-circle"
                  v-b-popover.hover.bottom="popoverContent"
                ></i>
              </template>
              <b-container fluid class="h-100">
                <b-row class="h-100">
                  <b-col class="h-100" cols="2">
                    <!--This is the dropdown main filter feature that filter
                    through the listing of instruments based on a research area.
                    The default value is 'axial-base.-->
                    <instruments-filter
                      :chart="chart"
                      :area="area"
                      :infrastructure="infrastructure"
                      :instrument="instrument"
                    ></instruments-filter>
                  </b-col>

                  <!-- End of filter -->
                  <!-- Container for data selection form, plot,
                  and instrument card list -->
                  <b-col class="h-100" cols="10">
                    <b-row style="height: 100%;">
                      <b-col id="v-step-10" cols="4" class="h-100">
                        <instruments-card></instruments-card>
                      </b-col>
                      <b-col id="v-step-8" cols="8" class="h-100">
                        <b-row class="h-50 flex-column justify-content-center">
                          <b-col class="h-100">
                            <trace-tabs
                              :chartUUID="chart.i"
                              :selectedTraceForm="`trace-form`">
                            </trace-tabs>
                          </b-col>
                        </b-row>
                        <b-row class="h-50 flex-column justify-content-center">
                          <b-col class="h-100">
                            <b-card no-body class="h-100 p-1" style="max-height: 100%;">
                              <!--Height is used to fit the plot next to form in container-->
                              <reactive-plot
                                :chartId="`${chart.i}-panel-plot`"
                                :chartUUID="chart.i"
                                v-if="chart.hasData"
                                class="plotly-chart-container"
                              ></reactive-plot>
                              <!--Overlays that will display if the chart has no data-->
                              <b-overlay :show="!chart.hasData" no-wrap>
                                <template v-slot:overlay>
                                  <!--First overlay - before user has selected any parameter.-->
                                  <div v-if="!chart.lastRequestParams">
                                    No data points yet. Please select parameters.
                                  </div>
                                  <!--Overlay displayed if there is a previous
                                  request and the plot is not loading-->
                                  <div v-if="chart.lastRequestParams && !chart.plotLoading">
                                    Plot has been reset. Please select new parameters.
                                  </div>
                                  <!--Overlay displayed when plot is loading-->
                                  <div v-if="chart.lastRequestParams && chart.plotLoading">
                                    Loading selected parameters...
                                    <b-spinner small variant="primary" label="Loading"></b-spinner>
                                  </div>
                                  <!--Overlay if user resets plot-->
                                  <!-- <div v-if="">
                                    The plot has been reset. Please select new parameters.
                                  </div> -->
                                </template>
                              </b-overlay>
                            </b-card>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- End of data selection form, plot,
                  and instrument card list -->
                </b-row>
              </b-container>
            </b-tab>

            <!-- This tabs content will not be mounted until the tab is shown -->
            <!-- and will be un-mounted when hidden -->
            <b-tab lazy title-link-class="detail-nav-link" class="h-100" :disabled="!chart.hasData">
              <template #title>
                <div id="v-step-11">
                  Plot style
                </div>
              </template>
              <b-container fluid class="h-100">
                <b-row class="style-plot-container pb-3">
                  <b-col class="h-100" cols="12" style="padding: unset;">
                    <b-card
                      class="h-100 w-100"
                      body-class="h-100"
                    >
                      <reactive-plot
                        :chartId="`${chart.i}-panel-plot`"
                        :chartUUID="chart.i"
                        v-if="chart.hasData"
                        class="plotly-chart-container"
                      ></reactive-plot>
                    </b-card>
                  </b-col>
                </b-row>
                <!--Form box will display only if the chart has data-->
                <b-row v-if="chart.hasData" class="style-form-container pt-3 pb-3">
                  <b-col class="h-100" cols="12">
                  <styling-form
                    :chartId="`${chart.i}`"
                    :chart="chart.chart"
                    :hasData="chart.hasData"
                    ></styling-form>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-col>
    <!-- MOUNT TOUR | name can be used anywhere to start the tour -->
    <v-tour :name="tourName" :steps="steps"></v-tour>
  </b-row>
</template>

<script>
/*
  Plot details page when editing plot content
*/
// import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import PlotVue from '../Plot';
import DownloadFormVue from './forms/DownloadForm';
import DownloadAlert from '../../alert/DownloadAlert';
import TraceTabsVue from './TraceTabs';
import InstrumentsCardVue from './InstrumentCards';
import InstrumentsFilterVue from './InstrumentFilter';
import StylingFormVue from './forms/StylingForm';
import getNewChart from '../../../utils/chartTools';

export default {
  components: {
    'reactive-plot': PlotVue,
    'download-form': DownloadFormVue,
    'instruments-card': InstrumentsCardVue,
    'instruments-filter': InstrumentsFilterVue,
    'styling-form': StylingFormVue,
    'trace-tabs': TraceTabsVue,
    'download-alert': DownloadAlert,
  },
  props: {
    area: {
      type: String,
      default: 'axial-base',
    },
    infrastructure: {
      type: String,
      default: '',
    },
    instrument: {
      type: String,
      default: '',
    },
    d: {
      type: String,
    },
    x: {
      type: String,
      default: null,
    },
    y: {
      type: String,
      default: null,
    },
    color_active: {
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
    color_min: {
      type: String,
      default: null,
    },
    color_max: {
      type: String,
      default: null,
    },
    color_theme: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      newChart: null,
      toastCounter: 0,
      tourName: 'vizDetailsTour',
      steps: [
        {
          target: '#v-step-0',
          content: 'Navigate through different applications by using the navbar, including the map, data visualization tools, and Jupyter notebooks.',
          params: {
            highlight: false,
          },
        },
        {
          target: '#v-step-1',
          content: 'Click to go back to main plots page to view the set of plots you have created.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-2',
          content: 'Select a research area of interest. You can click on the image below the dropdown menu to expand the map of the site and see which platforms and instruments are deployed there.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-3',
          content: 'Use the checkboxes to narrow down the available instrument cards on the right.',
          params: {
            highlight: true,
            placement: 'right',
          },
        },
        {
          target: '#v-step-4',
          content: 'This is the instrument listing panel, where you can see all instruments that are available to be plotted. This list can be narrowed down by using the filter checkboxes on the left.',
          params: {
            highlight: true,
            placement: 'top',
          },
        },
        {
          target: '#v-step-5',
          content: 'These instrument cards provide quick information about the location, name and identifying code, and the available parameters for each instrument.',
          params: {
            highlight: false,
            placement: 'top',
            enableScrolling: false,
          },
        },
        {
          target: '#v-step-6',
          content: 'Click to add data from this instrument to the plotting interface. Data from more than one instrument can be added to the plot.',
          params: {
            highlight: false,
          },
        },
        {
          target: '#v-step-7',
          content: 'Click to see more details about this instrument, including make, model, description, deployment information, and any annotations that indicate data quality or availability issues.',
          params: {
            highlight: false,
          },
        },
        {
          target: '#v-step-8',
          content: 'Once an instrument (or instruments) has been added to the dataset, you can use this panel to choose parameters to be plotted and the time range.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-9',
          content: 'Once you have selected parameters for the x and y axis, you will be able to download data. You will be able to choose between downloading a CSV or NetCDF file of the data.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-10',
          content: 'Your plot will be displayed here. It can take some time to plot larger datasets or longer time ranges, but you are able to create additional plots while your first plot loads.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-11',
          content: 'Navigate back and forth between data selection and plot styling by using these navigation tabs.',
          params: {
            highlight: false,
          },
        },
        {
          target: '#v-step-12',
          content: 'Click to add a new plot to the main plots page. You will automatically be brought to the data selections for the new plot.',
          params: {
            highlight: true,
          },
        },
      ],
    };
  },
  async created() {
    this.newChart = getNewChart(this.charts);
    /** Create new chart if doesn't exist */
    if (!this.chart) {
      const newChart = getNewChart(this.charts, this.$route.params.id);
      await this.addChart({ chart: newChart });
    }
  },
  async mounted() {
    if (!localStorage.getItem(this.tourName)) {
      /** Access the desired tour */
      this.$tours[this.tourName].start();
      localStorage.setItem(this.tourName, true);
    }
  },
  computed: {
    ...mapState({
      instruments: (state) => state.instruments,
      researchSites: (state) => state.areas.features,
      sites: (state) => state.sites.features,
    }),
    ...mapGetters('visualization/charts', {
      getChart: 'find',
      charts: 'list',
      chartsLength: 'count',
    }),
    ...mapGetters('visualization/traces', {
      getTraces: 'findByUUID',
      getTrace: 'find',
      isTabExists: 'exists',
      getInstruments: 'findSelectedInstruments',
    }),
    traceInstruments() {
      if (this.currentTrace) {
        /** Get selected instruments in current visible trace */
        return this.getInstruments(this.currentTrace.id);
      }
      return [];
    },
    uuid() {
      return this.$route.params.id;
    },
    chart() {
      if (this.chartsLength === 0) {
        return null;
      }
      return this.getChart(this.uuid);
    },
    traces() {
      return this.getTraces(this.uuid);
    },
    currentTrace() {
      if (this.traces.length > 0) {
        return this.getTrace(this.$route.query.d);
      }
      return null;
    },
    downloadBtnDisable() {
      if (this.traces.length === 0) {
        return false;
      }
      /**
       * Returns the downloadbtnvalue in the trace
       * Set to true/false based on if the form has an x and y
       */
      return this.currentTrace.downloadBtnValue;
    },
    tabIndex: {
      get() {
        if (!this.chart) {
          return 0;
        }
        return this.chart.currentTabIndex;
      },
      set(index) {
        this.setChartTab({ uuid: this.uuid, tabIndex: index });
      },
    },
    /**
     * Both title and content specified as a function in this example
     * and will be called the each time the popover is opened
     *
     * NOTE: this is called only when the popover is opened
     */
    popoverContent() {
      return {
        html: true,
        title: () => 'How does Interactive Oceans display large datasets?',
        content: () => 'Data shading is used in the plotting functionality to produce decimated plots:<br><a target="_blank" href="https://cormorack.github.io/resources/visualization/Datashading.html">Learn more</a>',
      };
    },
    /**
     * Both title and content specified as a function in this example
     * and will be called the each time the popover is opened
     */
    downloadHoverContent() {
      return {
        html: true,
        title: () => 'Data Download Disclaimer',
        content: () => 'The data download functionality is currently limited to a maximum of 8 months of data at a time. If a longer time range is needed, access via <a target="_blank" href="https://dataexplorer.oceanobservatories.org/">OOI Data Explorer.</a>',
      };
    },
  },
  methods: {
    ...mapActions('visualization/charts', ['addChart', 'setChartTab']),
    ...mapActions('visualization/traces', ['addTrace']),
    /**
     * Opens temporary toast when creating new plot
     * @param {*} toaster
     * @param {bool} append
     */
    toast(toaster, append = false) {
      // eslint-disable-next-line no-plusplus
      this.toastCounter++;
      this.$bvToast.toast('📈 You are now on a new plot.', {
        title: 'Plot Panel Successfully Created.',
        toaster,
        solid: true,
        appendToast: append,
        variant: 'success',
      });
    },
    /**
     * Adds new chart to chart listing
     */
    addNewChart() {
      this.addChart({ chart: this.newChart });
      this.newChart = getNewChart(this.charts);
    },
  },
  watch: {
    /**
     * Reacts to route changes
     * @param {Object} to - Route object where it's going to
     * @param {Object} from - Route object where it's coming from
     */
    $route(to, from) {
      if (to.path !== from.path) {
        this.addNewChart();
        this.toast('b-toaster-top-right');
      } else if (_.isEmpty(to.query)) {
        this.$router.push({ query: from.query });
      }
    },
  },
};
</script>

<style>
/* .card-header {
  position: fixed;
  width: 80.5%;
  z-index: 1000;
} */
.detail-nav {
  height: 5%;
}

.detail-container {
  height: 95%;
}

.detail-nav-link {
  color: #6c757d !important
}

.active.detail-nav-link:hover {
  border-color: transparent !important;
  background-color: #3995a32d !important;
  border-bottom: 2px solid #3995A3 !important;
  border-radius: 0 !important;
}

.detail-nav-link:hover {
  border-color: transparent !important;
  background-color: #e9e7e7bb !important;
  border-radius: 0 !important;
}

.border-top-bottom {
  border-bottom: 1px solid #dee2e6 !important;
  border-top: 1px solid #dee2e6 !important;
}

.bold-bottom-line {
  color: #3995A3 !important;
  font-weight: 800 !important;
  border-color: transparent !important;
  border-bottom: 2px solid #3995A3 !important;
  border-radius: 0 !important;
}

.plot-details {
  width: 100%;
  height: 100%;
}
/* Styling for the btn that will displayfeatures in progress */
.download-btn {
  text-decoration: none;
  position: relative;
  display: inline-block;
}
/* Styling for the badge on features in progress */
/* .download-btn .download-badge {
  position: absolute !important;
  top: -15px !important;
  left: -30px !important;
  padding: 5px 10px !important;
  border-radius: 50% !important;
  background-color: #a33960 !important;
  color: white !important;
  font-size: 0.5rem !important;
} */

.download-btn .download-disclaimer {
  position: absolute !important;
  top: -15px !important;
  left: -15px !important;
  padding: 8px !important;
  color: black !important;
  /* background-color: white !important; */
  font-size: 1rem !important;
}
.style-plot-container {
  height: 65%;
}
.style-form-container {
  height: 35%;
  overflow-y: scroll;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
}
</style>
